export default __webpack_public_path__ + "static/economic-performance-mobile-banner-df35abcf9f074d26187cc8236dd733dc.png";